import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import type { Store } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';

export default class AuthenticatedPslfDashboardForgivenessEstimatorResultsRoute extends Route {
  @service declare store: Store;
  @service declare sessionContext: SessionContextService;

  async model({ recommendation_id }: { recommendation_id: string }) {
    const { content } = (await this.store.request(
      findRecord<RecommendationModel>('recommendation', recommendation_id)
    )) as { content: { data: RecommendationModel } };
    return content.data;
  }
}
